/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconInfo = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 26 26"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 26px;
      `}
      {...props}
    >
      <g fill={fill} fillRule="nonzero">
        <path
          stroke={stroke}
          strokeWidth={weight === "normal" ? 1.5 : 1}
          d="M13 1C6.373 1 1 6.373 1 13s5.373 12 12 12 12-5.373 12-12c-.007-6.624-5.376-11.993-12-12z"
        />
        <path
          fill="currentColor"
          d="M13.25 6a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 13.25 6zM15.5 19.5h-4a1 1 0 0 1 0-2h.75a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25h-.75a1 1 0 0 1 0-2h1a2 2 0 0 1 2 2v4.75c0 .138.112.25.25.25h.75a1 1 0 0 1 0 2z"
        />
      </g>
    </svg>
  ),
);
